import { render } from "./OtherAmountLegacyView.vue?vue&type=template&id=1a40d469&scoped=true&ts=true"
import script from "./OtherAmountLegacyView.vue?vue&type=script&lang=ts"
export * from "./OtherAmountLegacyView.vue?vue&type=script&lang=ts"

import "./OtherAmountLegacyView.vue?vue&type=style&index=0&id=1a40d469&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a40d469"]])

export default __exports__